<template>
  <div class="profile-completeness-progress-info">
    <highlighted-text-block>
      <p class="paragraph paragraph-bold">
        {{ profileCompletenessNotification }}
        <span v-if="canHideNotification" @click="dismissNotification(profile_completed)">
          <svg-icon class="delete-icon" name="delete" width="9" height="9"></svg-icon>
        </span>
      </p>
      <progress-bar v-if="!isProfileCompleted"
                    :value="profileDetailsState.profile_completeness_progress">
      </progress-bar>
      <p v-if="!isProfileCompleted" class="paragraph">
        {{ profileCompletenessDescription }}
      </p>
    </highlighted-text-block>
  </div>
</template>

<script>

import 'top20common/distribution/icons/delete';

import ProgressBar from 'top20common/components/ProgressBar';
import HighlightedTextBlock from 'top20common/components/text-blocks/HighlightedTextBlock';
import {mapGetters} from 'vuex';

export default {
  data() {
    return {
      profile_completed: 'profile_completed'
    };
  },
  computed: {
    ...mapGetters(['profileDetailsState', 'isProfilePublished', 'isProfileCompleted']),
    labels() {
      return {
        makeProfileVisible: this.$gettext('Make your profile visible to employers'),
        profileRequiredPartsCompleteMsg: this.$gettext(
          'Complete the required part of your profile to increase your chances of getting an interview.'
        ),
        profileFullCompleteMsg: this.$gettext(
          'Complete your full profile today to increase your chances of getting an interview.'
        ),
        profileWaitForReview: this.$gettext('Your profile is pending to be reviewed by one of our Talent Advisors'),
        profileVisible: this.$gettext('Your profile is now visible to employers')
      };
    },
    profileReachPublishRequirements() {
      return this.profileDetailsState.all_required_filled;
    },
    canHideNotification() {
      return this.isProfileCompleted && this.isProfilePublished;
    },
    profileCompletenessNotification() {
      if (this.isProfilePublished) {
        return this.labels.profileVisible;
      }

      return this.profileReachPublishRequirements ? this.labels.profileWaitForReview : this.labels.makeProfileVisible;
    },
    profileCompletenessDescription() {
      return this.profileReachPublishRequirements
        ? this.labels.profileFullCompleteMsg
        : this.labels.profileRequiredPartsCompleteMsg;
    }
  },
  methods: {
    dismissNotification(name) {
      this.$store.dispatch('dismissNotification', name);
    }
  },
  components: {
    ProgressBar,
    HighlightedTextBlock
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.profile-completeness-progress-info {
  margin: 20px 0;

  /deep/ div.is-flex,
  div + p {
    margin-top: 10px;
  }

  /deep/ .text-highlighted {
    padding: 5px 20px;
  }

  /deep/ .paragraph-highlighted {
    margin-bottom: 0;
  }

  p {
    position: relative;

    .svg-icon {
      position: absolute;
      top: 7px;
      right: 0;
      cursor: pointer;

      /deep/ .stroke {
        stroke: var(--gray);
      }
    }
  }
}
</style>
